import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
import { getUserAgent } from '@/utils/index';

export default {
  namespace: 'knowLedgeExpand',
  state: {
    dataSource: [],
    pageSize: '',
    pageNum: '',
    total: '',
    infoList: [],
    AllInfoList: [],
    loading: false,
  },
  reducers: {
    setDataSource(state, action) {
      return {
        ...state,
        dataSource: action.payload,
        loading: false,
      };
    },
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
    setInfoList(state, action) {
      const { AllInfoList, pageNum } = state;
      if (pageNum !== action.payload.pageNum) {
        let DataSource = AllInfoList.concat(action.payload.records);
        return {
          ...state,
          pageNum: action.payload.pageNum,
          AllInfoList: DataSource,
          total: action.payload.total,
          infoList: DataSource,
          loading: false,
        };
      } else {
        return {
          ...state,
          pageNum: action.payload.pageNum,
          total: action.payload.total,
          loading: false,
        };
      }
    },
    setEmpty(state, action) {
      return {
        ...state,
        infoList: action.payload,
        AllInfoList: action.payload,
        total: '',
        pageNum: '',
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      const { callback = () => {}, parentId = '' } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = { parentId };
      const res = yield fetch.post(API.KNOWLEDGE_GET_LABEL, params);
      yield put({
        type: 'setDataSource',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback(res);
      }
    },
    *getExpandByLabel(action, { put }) {
      const { labelId, callback = () => {}, pageNum, pageSize } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = {
        pageNum,
        pageSize,
        labelId,
      };
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['appVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_INFO, params);
      yield put({
        type: 'setInfoList',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
    *getEmpty(action, { put }) {
      yield put({
        type: 'setEmpty',
        payload: [],
      });
    },
    *getInfoClick(action, { put }) {
      const { id } = action.payload;
      yield fetch.get(API.KNOWLEDGE_SUM_CLICK, { id });
    },
  },
};
